import React, { useEffect, useState } from 'react';
import { Clock, Heart } from 'lucide-react';
import { countdownText } from '../../services/shop';

/** Nuvarande tid, uppdaterad varje minut. */
const useMinuteClock = () => {
    const [now, setNow] = useState(() => Date.now());
    useEffect(() => {
        const id = window.setInterval(() => setNow(Date.now()), 30000);
        return () => window.clearInterval(id);
    }, []);
    return now;
};

/** "Kampanjen slutar om 8 dagar 14 h". Visas inte utan slutdatum. */
export const CampaignCountdown: React.FC<{ campaignEnd?: number; className?: string }> = ({ campaignEnd, className = '' }) => {
    const now = useMinuteClock();
    if (!campaignEnd) return null;
    const left = countdownText(campaignEnd, now);
    return (
        <span className={`inline-flex items-center gap-1.5 ${className}`}>
            <Clock size={14} aria-hidden="true" className="flex-shrink-0" />
            {left ? <>Kampanjen slutar om <strong className="font-bold tabular-nums">{left}</strong></> : 'Kampanjen är slut'}
        </span>
    );
};

/** Överst i gruppens butik: vem kunden stödjer och hur länge kampanjen pågår. */
export const SupportBar: React.FC<{ groupName?: string; sellerName?: string; campaignEnd?: number }> = ({ groupName, sellerName, campaignEnd }) => {
    if (!groupName) return null;
    return (
        // -mt-px och z-index: täcker en eventuell halv pixels glipa mot heron ovanför
        // (heron har en höjd i vh och blir ofta ett ojämnt antal pixlar).
        <div className="relative z-10 -mt-px bg-primary text-white">
            <div className="max-w-7xl mx-auto px-4 md:px-8 py-3 flex flex-wrap items-center justify-between gap-x-6 gap-y-1">
                <p className="flex items-center gap-2 text-sm md:text-base">
                    <Heart size={16} aria-hidden="true" className="flex-shrink-0" />
                    <span>Du stödjer <strong className="font-bold">{groupName}</strong>{sellerName && <span className="text-white/80"> genom {sellerName}</span>}</span>
                </p>
                <CampaignCountdown campaignEnd={campaignEnd} className="text-xs md:text-sm text-white/90" />
            </div>
        </div>
    );
};
